import { AssetImage } from "gql/generated";

/**
 * Determines the appropriate solid background color for a transparent image.
 *
 * Relies on the server-computed `lightness` field, which uses sharp to
 * sample actual pixel colors inside text bounding boxes. A dark background
 * is only applied when the server confirms the text is near-white
 * (and would disappear on a white page).
 *
 * Images without the server-computed fields (pre-backfill) get no
 * background — false negatives are preferable to false positives like
 * a dark bg behind a green-text logo.
 *
 * @returns "#000000" for white-text-on-transparent images, or null (no bg).
 */
export const getImageThumbnailBackgroundColor = (
  image?: Partial<AssetImage> | null,
): "#000000" | null => {
  if (!image) return null;

  if (image.hasTransparency === true && image.lightness === "light") {
    return "#000000";
  }

  return null;
};
